import Vue from 'vue';
import YorkbbsImage from '@/common/cover-image/cover-image.vue';

Vue.component('YorkbbsImage', YorkbbsImage);
